module.exports = ".width{width:100%}\n"